import React from 'react';
import { Dialog as DialogRaw, withStyles } from '@material-ui/core';

const Dialog = withStyles({
    paper: {
        border: '1px solid #66d0c3',
        borderRadius: '10px',
        margin: '0',
        maxHeight: '627px',
    }
})(DialogRaw);

const StyledInfoDialog = ({onClose, open, children }) => {
    return (
        <Dialog onClose={onClose} open={open}>
            {children}
        </Dialog>
    )
}
export default StyledInfoDialog;